<div class="charts-test">
  <h2>Chart.js Test</h2>
  <canvas #chartCanvas aria-label="Chart.js test canvas"></canvas>
  <button class="btn btn-primary" type="button" (click)="refreshChart()">Refresh Chart</button>
</div>
